import Debug from 'debug';
import _ from 'lodash';
import moment from 'moment-timezone';
const debug = Debug(`knack.core.helpers.reports.processSQLDateTimeGroupDay`);
export const processSQLDateTimeGroupDay = (group, old_filters, field, app_now, column, filter, report, current_moment_time) => {
    debug(`report-helper.processSQLDateTimeGroupDay`);
    let limit;
    let offset;
    if (group.limit == `from_to` || group.limit == `from`) {
        // set start and limit
        let now = _.cloneDeep(current_moment_time);
        var to = (group.limit == `from_to`) ? moment(new Date(group.date_to)) : now;
        var from = moment(new Date(group.date_from));
        // convert to same times
        now = moment(new Date(now.format(`MM/DD/YY`)));
        from = moment(new Date(from.format(`MM/DD/YY`)));
        to = moment(new Date(to.format(`MM/DD/YY`)));
        debug(`from: ${from.format(`MM/DD/YY`)} to: ${to.format(`MM/DD/YY`)}; diff: ${to.diff(from, `days`)}; diff (true): ${to.diff(from, `days`, true)}; from: ${now.diff(from, `days`, true)}; offset(true): ${now.diff(to, `days`, true)}`);
        var start = now.diff(from, `days`, true); // positive is in the past
        limit = to.diff(from, `days`, true) + 1;
        offset = now.diff(to, `days`, true); // a negative offset means it's going into the future
    }
    else {
        limit = group.number;
        offset = 0;
    }
    if (limit === 0) {
        limit = 1;
    }
    debug(`difference in days, limit is: ${limit}; offset is: ${offset}; start is: ${start}`);
    const spans_years = limit > 365;
    if (field && field.type === `date_time` && field.format && field.format.date_format === `Ignore Date`) {
        // this is basically saying "select anything with a time at all." what should really happen is that we should add hour, minute, etc intervals instead for ignore date date/time fields
        const d = _.cloneDeep(current_moment_time);
        d.subtract(offset, `days`);
        let date_format = `MM/DD`;
        if (spans_years) {
            date_format += `/YY`;
        }
        const header = d.format(date_format);
        from.year(2012).month(0).day(0).hours(0).minutes(0).seconds(0);
        to.year(2012).month(0).day(0).hours(23).minutes(59).seconds(59);
        const value = [
            from.toDate(),
            to.toDate()
        ];
        const new_filter = _.cloneDeep(filter);
        new_filter.push({
            field: group.field,
            operator: `is date range`,
            value,
            header
        });
        report.filters.unshift(new_filter);
        if (column === 0) {
            report.filter_groups[report.filter_groups.length - 1].unshift({
                header
            });
        }
    }
    else {
        _(limit).times(function (i) {
            debug(`building SQL datetime values for report grouping ${i + offset}`);
            if (group.sort === `asc`) {
                i = (limit - 1) - i;
            }
            const d = _.cloneDeep(current_moment_time);
            let date_format = `MM/DD`;
            d.subtract(i + offset, `days`);
            if (group && group.field) {
                if (field && field.format && field.format.date_format === `dd/mm/yyyy`) {
                    date_format = `DD/MM`;
                }
            }
            if (spans_years) {
                date_format += `/YY`;
            }
            const header = d.format(date_format);
            const from = (new moment(app_now).utc()).subtract(1, `days`).endOf(`day`);
            const to = (new moment(app_now).utc()).subtract(1, `days`).endOf(`day`);
            debug(`from/to ${from.format()} ${to.format()}`);
            if (i + offset > 0) {
                from.subtract((i + offset), `days`);
            }
            else if (i + offset < 0) {
                from.add(0 - (i + offset), `days`);
            }
            from.subtract(1, `seconds`);
            const value = [
                from.toDate()
            ];
            if (i + offset === 0) {
                to.add(1, `days`);
            }
            else if (i + offset > 1) {
                to.subtract((i + offset - 1), `days`);
            }
            else if (i + offset === 1) {
                // nothing to do for this case
            }
            else {
                to.add((0 - (i + offset - 1)), `days`);
            }
            to.subtract(1, `seconds`);
            value.push(to.toDate());
            debug(`value for offset ${i + offset} is: ${JSON.stringify(value)}`);
            debug(value);
            const new_filter = _.cloneDeep(filter);
            new_filter.push({
                field: group.field,
                operator: `is date range`,
                value,
                header
            });
            report.filters.unshift(new_filter);
            if (column === 0) {
                report.filter_groups[report.filter_groups.length - 1].unshift({
                    header
                });
            }
        });
    }
};
